"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormPhoneNumber", {
    enumerable: true,
    get: function() {
        return FormPhoneNumber;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _reactphoneinput2 = /*#__PURE__*/ _interop_require_default(require("react-phone-input-2"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _usePhoneNumberLocalization = require("./usePhoneNumberLocalization");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const DEFAULT_DROPDOWN_WIDTH_PX = 300;
const valueIfString = (val)=>typeof val === "string" && val !== "" ? val : null;
const getLineHeight = (variant)=>{
    switch(variant){
        case "lg":
            return "24px";
        case "sm":
            return "16px";
        default:
            return "22px";
    }
};
const getCountryGuess = (timezone)=>{
    if (timezone == null) {
        return "au";
    }
    if (timezone.startsWith("Europe/Dublin")) {
        return "ie";
    }
    if (timezone.startsWith("Europe")) {
        return "gb";
    }
    if (timezone.startsWith("Australia")) {
        return "au";
    }
    if (timezone.startsWith("America")) {
        return "us";
    }
    if (timezone.startsWith("Canada")) {
        return "ca";
    }
    return "au";
};
const getPlaceholder = (countryGuess)=>{
    switch(countryGuess){
        case "ie":
            return "Eg. +35312345678";
        case "gb":
            return "Eg. +447911123456";
        case "us":
            return "Eg. +12005550000";
        case "ca":
            return "Eg. +12005550000";
        default:
            return "Eg. +61444123456";
    }
};
const getPreferredCountries = (countryGuess)=>{
    switch(countryGuess){
        case "ie":
            return [
                "ie",
                "au",
                "gb",
                "us",
                "ca"
            ];
        case "gb":
            return [
                "gb",
                "au",
                "us",
                "ie",
                "ca"
            ];
        case "us":
            return [
                "us",
                "au",
                "gb",
                "ie",
                "ca"
            ];
        case "ca":
            return [
                "ca",
                "us",
                "au",
                "gb",
                "ie"
            ];
        default:
            return [
                "au",
                "gb",
                "us",
                "ie",
                "ca"
            ];
    }
};
/**
 * PhoneInput generates some fairly unhelpful change events. Fiddle with the
 * event object to make it useful for external consumers.
 */ const sanitiseChangeEvent = (e, newValue, param, inputElement)=>{
    let { dialCode = "" } = param;
    if (inputElement != null && e.target !== inputElement) {
        // The user has made a selection from the country dropdown and the
        // event target is the dropdown list item (which is not an input element, so
        // the type of the event is a lie...).
        //
        // Formik (or anything else...) won't know what to do with this event
        // because its target doesn't have the `id` / `name` / `value` attributes of
        // the form field, so manually update the event target to the input element.
        e.target = inputElement;
    }
    // Properly format the phone number with leading `+`, dial code, and no
    // leading zeroes.
    const sanitised = newValue.replace(new RegExp("^\\+?".concat(dialCode, "0?"), "u"), "+".concat(dialCode));
    e.target.value = sanitised === "+".concat(dialCode) ? "" : sanitised;
    return e;
};
const FormPhoneNumber = /*#__PURE__*/ (0, _react.forwardRef)((param, outerRef)=>{
    let { siteTimezone, value: valueProp, variant, rounded, showChrome, disabled = false, onChange, onFocus, onBlur, ...inputProps } = param;
    const { colors, animationDuration, borderRadius } = (0, _Theme.useTheme)();
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        selector: ".phone-input",
        rounded,
        showChrome
    });
    const padding = (0, _useInputPadding.useInputPadding)();
    const { id, hintId, hasError = false } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const locale = (0, _usePhoneNumberLocalization.usePhoneNumberLocalization)();
    var _valueIfString;
    const [localValue, setLocalValue] = (0, _react.useState)((_valueIfString = valueIfString(valueProp)) !== null && _valueIfString !== void 0 ? _valueIfString : "");
    const [focused, setFocused] = (0, _react.useState)(false);
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        // Work around to get elements in correct order for keyboard nav.
        if (ref.current != null) {
            try {
                const flags = ref.current.querySelector(".flag-dropdown");
                const input = ref.current.querySelector("input");
                if (input != null && flags != null) {
                    var _flags_parentElement;
                    (_flags_parentElement = flags.parentElement) === null || _flags_parentElement === void 0 ? void 0 : _flags_parentElement.insertBefore(flags, input);
                }
            } catch  {
            // Meh... I tried.
            }
        }
    }, []);
    const [dropdownWidth, setDropdownWidth] = (0, _react.useState)(DEFAULT_DROPDOWN_WIDTH_PX);
    (0, _react.useEffect)(()=>{
        const element = ref.current;
        if (element == null) {
            setDropdownWidth(DEFAULT_DROPDOWN_WIDTH_PX);
            return ()=>undefined;
        }
        const observer = new ResizeObserver((entries)=>entries.forEach((entry)=>setDropdownWidth(entry.contentRect.width)));
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, []);
    const inputRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(outerRef, ()=>{
        var _inputRef_current;
        return (_inputRef_current = inputRef.current) !== null && _inputRef_current !== void 0 ? _inputRef_current : document.createElement("input");
    }, []);
    const countryGuess = getCountryGuess(siteTimezone);
    var _inputProps_id;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: ref,
        className: _style.default.dynamic([
            [
                "3ef4052571c5ed64",
                [
                    animationDuration,
                    disabled ? "0.5" : "1",
                    colors.border,
                    borderRadius,
                    hasError ? 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTQnIGhlaWdodD0nMTQnIHZpZXdCb3g9JzAgMCAxNCAxNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNNy4wMDA2NSAxMy42NjY3QzMuMzE4NjUgMTMuNjY2NyAwLjMzMzk4NCAxMC42ODIgMC4zMzM5ODQgNy4wMDAwNEMwLjMzMzk4NCAzLjMxODA0IDMuMzE4NjUgMC4zMzMzNzQgNy4wMDA2NSAwLjMzMzM3NEMxMC42ODI3IDAuMzMzMzc0IDEzLjY2NzMgMy4zMTgwNCAxMy42NjczIDcuMDAwMDRDMTMuNjY3MyAxMC42ODIgMTAuNjgyNyAxMy42NjY3IDcuMDAwNjUgMTMuNjY2N1pNNy4wMDA2NSAxMi4zMzM0QzguNDE1MTQgMTIuMzMzNCA5Ljc3MTY5IDExLjc3MTUgMTAuNzcxOSAxMC43NzEzQzExLjc3MjEgOS43NzEwOCAxMi4zMzQgOC40MTQ1MyAxMi4zMzQgNy4wMDAwNEMxMi4zMzQgNS41ODU1NSAxMS43NzIxIDQuMjI5IDEwLjc3MTkgMy4yMjg4QzkuNzcxNjkgMi4yMjg2MSA4LjQxNTE0IDEuNjY2NzEgNy4wMDA2NSAxLjY2NjcxQzUuNTg2MTYgMS42NjY3MSA0LjIyOTYxIDIuMjI4NjEgMy4yMjk0MSAzLjIyODhDMi4yMjkyMiA0LjIyOSAxLjY2NzMyIDUuNTg1NTUgMS42NjczMiA3LjAwMDA0QzEuNjY3MzIgOC40MTQ1MyAyLjIyOTIyIDkuNzcxMDggMy4yMjk0MSAxMC43NzEzQzQuMjI5NjEgMTEuNzcxNSA1LjU4NjE2IDEyLjMzMzQgNy4wMDA2NSAxMi4zMzM0Wk02LjMzMzk4IDkuMDAwMDRINy42NjczMlYxMC4zMzM0SDYuMzMzOThWOS4wMDAwNFpNNi4zMzM5OCAzLjY2NjcxTDcuNjY3MzIgMy42NjY3MVY3LjY2NjcxSDYuMzMzOThWMy42NjY3MVonIGZpbGw9JyNFNjAwMEUnLz48L3N2Zz4=")\n              no-repeat calc(100% - 14px) center' : disabled ? colors.grayscale[3] : "white",
                    colors.inputBorder,
                    dropdownWidth,
                    borderRadius,
                    variant === "lg" ? "16px" : "14px",
                    getLineHeight(variant),
                    padding.shorthand,
                    colors.muted1
                ]
            ]
        ]) + " " + "phone-input ".concat(focused ? "focused" : "", " ").concat(disabled ? "disabled" : "")
    }, locale.ready && /*#__PURE__*/ _react.default.createElement(_reactphoneinput2.default, {
        country: countryGuess,
        placeholder: getPlaceholder(countryGuess),
        preferredCountries: getPreferredCountries(countryGuess),
        preserveOrder: [
            "preferredCountries"
        ],
        localization: locale.localization,
        autoFormat: false,
        countryCodeEditable: false,
        specialLabel: "",
        inputProps: {
            ...inputProps,
            "id": (_inputProps_id = inputProps.id) !== null && _inputProps_id !== void 0 ? _inputProps_id : id,
            "aria-describedby": hintId,
            "ref": inputRef
        },
        disabled: disabled,
        value: localValue,
        onChange: (newValue, data, e)=>{
            setLocalValue(newValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(sanitiseChangeEvent(e, newValue, data, inputRef.current));
        },
        onFocus: (e)=>{
            setFocused(true);
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        },
        onBlur: (e)=>{
            setFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        }
    })), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "3ef4052571c5ed64",
        dynamic: [
            animationDuration,
            disabled ? "0.5" : "1",
            colors.border,
            borderRadius,
            hasError ? 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTQnIGhlaWdodD0nMTQnIHZpZXdCb3g9JzAgMCAxNCAxNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNNy4wMDA2NSAxMy42NjY3QzMuMzE4NjUgMTMuNjY2NyAwLjMzMzk4NCAxMC42ODIgMC4zMzM5ODQgNy4wMDAwNEMwLjMzMzk4NCAzLjMxODA0IDMuMzE4NjUgMC4zMzMzNzQgNy4wMDA2NSAwLjMzMzM3NEMxMC42ODI3IDAuMzMzMzc0IDEzLjY2NzMgMy4zMTgwNCAxMy42NjczIDcuMDAwMDRDMTMuNjY3MyAxMC42ODIgMTAuNjgyNyAxMy42NjY3IDcuMDAwNjUgMTMuNjY2N1pNNy4wMDA2NSAxMi4zMzM0QzguNDE1MTQgMTIuMzMzNCA5Ljc3MTY5IDExLjc3MTUgMTAuNzcxOSAxMC43NzEzQzExLjc3MjEgOS43NzEwOCAxMi4zMzQgOC40MTQ1MyAxMi4zMzQgNy4wMDAwNEMxMi4zMzQgNS41ODU1NSAxMS43NzIxIDQuMjI5IDEwLjc3MTkgMy4yMjg4QzkuNzcxNjkgMi4yMjg2MSA4LjQxNTE0IDEuNjY2NzEgNy4wMDA2NSAxLjY2NjcxQzUuNTg2MTYgMS42NjY3MSA0LjIyOTYxIDIuMjI4NjEgMy4yMjk0MSAzLjIyODhDMi4yMjkyMiA0LjIyOSAxLjY2NzMyIDUuNTg1NTUgMS42NjczMiA3LjAwMDA0QzEuNjY3MzIgOC40MTQ1MyAyLjIyOTIyIDkuNzcxMDggMy4yMjk0MSAxMC43NzEzQzQuMjI5NjEgMTEuNzcxNSA1LjU4NjE2IDEyLjMzMzQgNy4wMDA2NSAxMi4zMzM0Wk02LjMzMzk4IDkuMDAwMDRINy42NjczMlYxMC4zMzM0SDYuMzMzOThWOS4wMDAwNFpNNi4zMzM5OCAzLjY2NjcxTDcuNjY3MzIgMy42NjY3MVY3LjY2NjcxSDYuMzMzOThWMy42NjY3MVonIGZpbGw9JyNFNjAwMEUnLz48L3N2Zz4=")\n              no-repeat calc(100% - 14px) center' : disabled ? colors.grayscale[3] : "white",
            colors.inputBorder,
            dropdownWidth,
            borderRadius,
            variant === "lg" ? "16px" : "14px",
            getLineHeight(variant),
            padding.shorthand,
            colors.muted1
        ]
    }, ".phone-input.__jsx-style-dynamic-selector{-webkit-transition:".concat(animationDuration, " box-shadow,border;-moz-transition:").concat(animationDuration, " box-shadow,border;-o-transition:").concat(animationDuration, " box-shadow,border;transition:").concat(animationDuration, " box-shadow,border;width:100%;height:40px;opacity:").concat(disabled ? "0.5" : "1", ";border:1px solid ").concat(colors.border, ";-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, ";background:").concat(hasError ? 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTQnIGhlaWdodD0nMTQnIHZpZXdCb3g9JzAgMCAxNCAxNCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNNy4wMDA2NSAxMy42NjY3QzMuMzE4NjUgMTMuNjY2NyAwLjMzMzk4NCAxMC42ODIgMC4zMzM5ODQgNy4wMDAwNEMwLjMzMzk4NCAzLjMxODA0IDMuMzE4NjUgMC4zMzMzNzQgNy4wMDA2NSAwLjMzMzM3NEMxMC42ODI3IDAuMzMzMzc0IDEzLjY2NzMgMy4zMTgwNCAxMy42NjczIDcuMDAwMDRDMTMuNjY3MyAxMC42ODIgMTAuNjgyNyAxMy42NjY3IDcuMDAwNjUgMTMuNjY2N1pNNy4wMDA2NSAxMi4zMzM0QzguNDE1MTQgMTIuMzMzNCA5Ljc3MTY5IDExLjc3MTUgMTAuNzcxOSAxMC43NzEzQzExLjc3MjEgOS43NzEwOCAxMi4zMzQgOC40MTQ1MyAxMi4zMzQgNy4wMDAwNEMxMi4zMzQgNS41ODU1NSAxMS43NzIxIDQuMjI5IDEwLjc3MTkgMy4yMjg4QzkuNzcxNjkgMi4yMjg2MSA4LjQxNTE0IDEuNjY2NzEgNy4wMDA2NSAxLjY2NjcxQzUuNTg2MTYgMS42NjY3MSA0LjIyOTYxIDIuMjI4NjEgMy4yMjk0MSAzLjIyODhDMi4yMjkyMiA0LjIyOSAxLjY2NzMyIDUuNTg1NTUgMS42NjczMiA3LjAwMDA0QzEuNjY3MzIgOC40MTQ1MyAyLjIyOTIyIDkuNzcxMDggMy4yMjk0MSAxMC43NzEzQzQuMjI5NjEgMTEuNzcxNSA1LjU4NjE2IDEyLjMzMzQgNy4wMDA2NSAxMi4zMzM0Wk02LjMzMzk4IDkuMDAwMDRINy42NjczMlYxMC4zMzM0SDYuMzMzOThWOS4wMDAwNFpNNi4zMzM5OCAzLjY2NjcxTDcuNjY3MzIgMy42NjY3MVY3LjY2NjcxSDYuMzMzOThWMy42NjY3MVonIGZpbGw9JyNFNjAwMEUnLz48L3N2Zz4=")\n              no-repeat calc(100% - 14px) center' : disabled ? colors.grayscale[3] : "white", "}.phone-input.focused.__jsx-style-dynamic-selector{cursor:auto;border:1px solid ").concat(colors.inputBorder, "!important;-webkit-box-shadow:0 0 0 4px rgba(48,48,252,.1)!important;-moz-box-shadow:0 0 0 4px rgba(48,48,252,.1)!important;box-shadow:0 0 0 4px rgba(48,48,252,.1)!important}.phone-input.__jsx-style-dynamic-selector .flag-dropdown{z-index:1;background:inherit;border-width:0;border-right-width:1px}.phone-input.__jsx-style-dynamic-selector .flag-dropdown:before{display:none}.phone-input.__jsx-style-dynamic-selector .country-list{width:").concat(dropdownWidth, "px;margin-top:4px;padding:8px 0;-webkit-border-radius:").concat(borderRadius, ";-moz-border-radius:").concat(borderRadius, ";border-radius:").concat(borderRadius, "}.phone-input.__jsx-style-dynamic-selector .country{margin:0 8px;padding:4px 8px;font-size:.8rem}.phone-input.__jsx-style-dynamic-selector .selected-flag{width:40px;background:inherit!important}.phone-input.__jsx-style-dynamic-selector input{font-size:").concat(variant === "lg" ? "16px" : "14px", "!important;line-height:").concat(getLineHeight(variant), "!important;-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;float:none;outline:none;border:none;background:none;width:100%;height:unset;padding:").concat(padding.shorthand, ";padding-left:46px;cursor:pointer}.phone-input.__jsx-style-dynamic-selector input::placeholder{color:").concat(colors.muted1, "}.phone-input.disabled.__jsx-style-dynamic-selector .flag-dropdown,.phone-input.disabled.__jsx-style-dynamic-selector input{cursor:unset}")), borderCss.styles);
});
FormPhoneNumber.displayName = "FormPhoneNumber";

//# sourceMappingURL=FormPhoneNumber.js.map